// extracted by mini-css-extract-plugin
module.exports = {"grid_item_wrapper":"virtualized-voices-grid_grid_item_wrapper__m6Dqo","wrapper":"virtualized-voices-grid_wrapper__uXfTO","grid":"virtualized-voices-grid_grid__vuqnZ"};